import {PaymentTypes} from "app/app.types";
import { LocaleService } from 'app/services/locale/locale.service';
import {ScheduleFilterService} from "external-services/schedule-filter-service/scheduleFilter.service";
import {BookingStatusNames, BookingStatusTypes} from "app/bookingStatusTypes";
import ConvertJsonToCsv from "app/services/jsonToCsv/jsonToCsv.service";
import PhoneNumberService from "app/services/phoneNumber/phoneNumber.service";
import { CustomerGeneratorService } from "external-services/customer-generator-service";
import BookingService from "app/services/booking/booking.service";
import BookingChangeService from "external-services/booking-change-service/bookingChange.service";
import { BookingCancelledReason, BookingStateChangeTypes, SECTION_ANY_ID } from "shared-types/index";
import DateUtilsService from 'external-services/date-utils-service';
import AdminService from 'external-services/diary-admin-service/admin.service';

const NS = 'CancelledNoShowBookingsCtrl';

export default function CancelledNoShowBookingsCtrl(
  $scope, $filter, $timeout, scheduleService, unregister
) {

  "ngInject";

  var vm = this;
  //-- define public properties
  vm.loading = false;
  vm.filterBookings = [];
  const timezoneId = AdminService.getVenueTimezoneId();
  vm.startDate = DateUtilsService.getClearDate(null, timezoneId);
  vm.endDate = DateUtilsService.getClearDate(null, timezoneId);
  vm.paxMin = 1;
  vm.paxMax = null;
  vm.endDate.setDate(vm.endDate.getDate() + 30);
  vm.hideDays = true;
  vm.cancelledBookings = [];
  let listeners;
  // methods
  vm.loadResults = loadResults;
  vm.printReport = printReport;
  vm.exportToCsv = exportToCsv;

  loadResults();

  //-- listen
  listeners = [];
  listeners.push($scope.$watch('vm.startDate', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      datesChanged()
    }
  }));
  listeners.push($scope.$watch('vm.endDate', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      datesChanged()
    }
  }));
  listeners.push($scope.$watch('vm.paxMin', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      loadResults()
    }
  }));
  listeners.push($scope.$watch('vm.paxMax', function (newValue, oldValue) {
    if (newValue !== oldValue) {
      loadResults()
    }
  }));

  vm.$onDestroy = () => {
    unregister(listeners);
  };

  function datesChanged() {
    if (vm.startDate && (!vm.endDate || vm.endDate.getTime() >= vm.startDate.getTime())) {
      loadResults();
    }
  }

  function loadResults() {
    vm.loadError = false;
    vm.loading = true;
    BookingService.getBetweenDates(vm.startDate, vm.endDate).then(function (bookings) {
      return filterBookings(bookings);
    }).then(function (filteredBooking) {
      vm.filterBookings = filteredBooking.sort(function (a, b) {
        return a.time - b.time;
      });
      vm.loadError = false;
      vm.loading = false;
    }).catch(function () {
      // data failed to load
      vm.loadError = true;
      vm.loading = false;
    });
  }

  /**
   * We are filtering the bookings based on the people and if its valid cancellation - Valid cancellation means we are
   * ignoring the cancelled booking cause by change_date.
   * @param bookings
   * @returns {*}
   */

  function filterBookings(bookings) {
    vm.cancelledBookings = [];
    if (bookings.length > 0) {
      return new Promise((resolve) => {
        const val = []
        bookings.forEach((booking, index) => {
          return isValidCancellation(booking).then((isValid) => {
            if (booking.people >= vm.paxMin && (!vm.paxMax || booking.people <= vm.paxMax) && isValid) {
              val.push(booking)
            }
            if (index === bookings.length - 1) {
              resolve(val)
            }
          })
        });
      })
    } else {
      Promise.resolve([])
    }
  }


  // Cant write tests as i need to save cancelled bookings in vm.cancelledBookings - hence I cannot move this to another service
  function isValidCancellation(booking) {
    if (booking.status?.statusType !== BookingStatusTypes.Cancelled) {
      return Promise.resolve(false);
    }

    //Ignore any bookings cancelled due to edits or moved
    if(booking.cancelledReason === BookingCancelledReason.editMoved){
      return Promise.resolve(false);
    }

    //We should aim to deprecate everything below here in favor of using the simpler cancelled reason above.
    let isDateChanged = false;

        return BookingChangeService.getChanges(booking).then((changesObj) => {
      isDateChanged = changesObj.changes.filter(changes => changes.type === BookingStateChangeTypes.DATE_CHANGED).length > 0;
      if (!isDateChanged) {
        changesObj.changes.forEach((changes) => {
          const change = changes.changeList.filter(changeList => changeList.property === 'status' && (changeList.newValue === BookingStatusNames.Cancelled || changeList.newValue === BookingStatusNames.CancelledNoShow));
          if (change.length > 0) {
            booking.changes = changes;
          }
        })
        vm.cancelledBookings.push(booking);
      }
      return !isDateChanged;
    }).catch(function () {
      console.log('bookingChange --- ERROR')
      return false;
    });
  }

  function exportToCsv() {
    ScheduleFilterService.getServicesFromGetSchedule().then((services) => {

      vm.cancelledBookings = ScheduleFilterService.removeDuplicates(vm.cancelledBookings, '_id');

      var reportName = 'NoShowCancellation_' + LocaleService.formatDateForFilename(vm.startDate) + '_EndDate_' + LocaleService.formatDateForFilename(vm.endDate) + '_' + vm.paxMin;
      if (vm.paxMax) {
        reportName += '_' + vm.paxMax;
      }
      var bookingRows = [];
      var labels = ['Customer', 'Phone', 'Email', 'Service', 'Date', 'Pre Auth', 'Charged', 'Transaction ID', 'Status', 'Pax', 'Cancellation Date', 'Method'];
      // Loop over booking totals

      for (var i = 0; i < vm.cancelledBookings.length; i++) {
        var booking = vm.cancelledBookings[i];

        const serviceVal = services.find((service) => service.id === booking.serviceId);
        const paymentType = booking.paymentDetails ? booking.paymentDetails.paymentType : booking.paymentSummary?.paymentType;
        const isCharged = booking.paymentSummary && booking.paymentSummary.preAuthStatus === 'Completely Charged' || false;
        const transactionId = booking.paymentSummary && booking.paymentSummary.transactionId || '';
        // Split combined datetime: localise date, keep time unchanged
        const changeTime = booking.changes?.time;
        const dateTime = changeTime
          ? LocaleService.formatDate(new Date(changeTime), 'short') + ' ' + $filter('date')(changeTime, 'HH:mm')
          : '';
        const method = booking.changes ? booking.changes.method : '';
        var rowObj = {
          customer: CustomerGeneratorService.getDisplayName(booking),
          phone: booking.subscribed && booking.phone ? PhoneNumberService.formatNumber(booking.phone) : '',
          email: booking.subscribed && booking.email ? booking.email : '',
          serviceName: serviceVal?.name || SECTION_ANY_ID,
          // Split combined datetime: localise date portion, keep time unchanged
          date: LocaleService.formatDate(booking.time, 'medium-short') + ' ' + $filter('date')(booking.time, 'h:mma'),
          preAuth: paymentType === PaymentTypes.PreAuth ? 'Yes' : 'No',
          charged: isCharged ? 'Yes' : 'No',
          transactionId: transactionId,
          status: booking.status?.name,
          pax: booking.people,
          cancellationDate: dateTime,
          method: method
        };
        bookingRows.push(rowObj);
      }

      ConvertJsonToCsv.downloadCsv(bookingRows, labels, reportName);
    });


  }

  function printReport() {
    vm.printing = true;
    $timeout(function () {
      setTimeout(function () {
        window.print();
        printDone();
      }, 200);
    }, 100);
  }

  function printDone() {
    vm.printing = false;
    setTimeout(function () {
      vm.printing = false;
    }, 200);
  }
}
